import { hrmsPost } from "../api/api";



export function changePassword({ currentPassword, newPassword, confirmPassword }) {
  return hrmsPost(
     "/profile-settings/chg-pwd",
    { currentPassword, newPassword, confirmPassword },
    "HR01A"
  );
}